module.exports = __webpack_public_path__ + "img/hero-image.6afdfa79.jpg";